import Vue from 'vue'
import Router from 'vue-router'

import LoginView from '@/views/Login'
import InicioView from '@/views/Inicio'
import DashboardView from '@/views/Dashboard'
import ProductView from '@/views/manage/Product'
import OrderSupplierView from '@/views/manage/OrderSupplier'
import InventoryView from '@/views/manage/Inventory'
import HomeImage from '@/views/manage/HomeImage'
import OrderView from '@/views/order/Order'
import OrderProfitView from '@/views/order/OrderProfit'
import ProductsImageView from '@/views/marketing/ProductsImage'
import SaleView from '@/views/order/Sale'
import ReceivableView from '@/views/order/Receivable'
import DeliveryCalendarView from '@/views/order/DeliveryCalendar'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: LoginView
    },
    {
      path: '/inicio',
      name: 'Inicio',
      component: InicioView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/manage/product',
      name: 'Product',
      component: ProductView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/manage/order-supplier',
      name: 'OrderSupplier',
      component: OrderSupplierView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/manage/inventory',
      name: 'Inventory',
      component: InventoryView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/manage/home-image',
      name: 'HomeImage',
      component: HomeImage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order/order',
      name: 'Order',
      component: OrderView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order/profit',
      name: 'Profit',
      component: OrderProfitView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order/sale',
      name: 'Sale',
      component: SaleView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order/receivable',
      name: 'Receivable',
      component: ReceivableView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/marketing/products-image',
      name: 'ProductsImage',
      component: ProductsImageView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order/delivery-calendar',
      name: 'DeliveryCalendar',
      component: DeliveryCalendarView,
      meta: {
        requiresAuth: true
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  // const currentUser = firebase.auth().currentUser;
  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // if (requiresAuth && !currentUser) {
  //   next('');
  // } else if (!requiresAuth && currentUser) {
  //   next('inicio');
  // } else {
    next();
  // }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js